import script from "./minimalism.vue?vue&type=script&lang=ts&setup=true"
export * from "./minimalism.vue?vue&type=script&lang=ts&setup=true"

import "./minimalism.vue?vue&type=style&index=0&id=c5e0309c&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5e0309c"]])

export default __exports__